module.exports = __webpack_public_path__ + "static/media/1002347.dfba9acb.png";